import { GLOBAL, HOSPITAL } from '@constants';

function extractSourceFromOwnerId(ownerId: string) {
  if (ownerId && ownerId.includes(HOSPITAL)) return HOSPITAL;

  return GLOBAL;
}

export default extractSourceFromOwnerId;
